import React from 'react';
import './RadiusSelector.css';

interface RadiusSelectorProps {
  selectedRadius: number;
  onRadiusChange: (radius: number) => void;
  disabled?: boolean;
}

const RadiusSelector: React.FC<RadiusSelectorProps> = ({
  selectedRadius,
  onRadiusChange,
  disabled = false
}) => {
  const radiusOptions = [
    { value: 10, label: '10 miles' },
    { value: 20, label: '20 miles' },
    { value: 30, label: '30 miles' }
  ];

  return (
    <div className="radius-selector">
      <div className="radius-selector-label">
        <i className="material-icons">location_on</i>
        Coverage Area
      </div>
      <div className="radius-buttons">
        {radiusOptions.map((option) => (
          <button
            key={option.value}
            className={`radius-btn ${selectedRadius === option.value ? 'active' : ''}`}
            onClick={() => onRadiusChange(option.value)}
            disabled={disabled}
            title={`Show data within ${option.label} of dealer location`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RadiusSelector;